import React, { Component } from "react";
import { DeviceContext } from "context/deviceProvider";
import LetterLoading from "components/loading/letterLoading";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/deviceStructure/deviceNumber.scss";
import {
  Button,
  Form,
  Icon,
  Pagination,
  Select,
  Table,
} from "semantic-ui-react";
import Swal from "sweetalert2";
import AddDeviceNumberModal from "components/deviceStructure/addDeviceNumberModal";

export default class DeviceNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      serialSearch: "",
      devicesList: [],
      begin: 0,
      end: 10,
      pageSize: 10,
      activePage: 1,
      addDeviceNumber: false,
    };
  }

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });

  updateAddDeviceNumber = () =>
    this.setState({ addDeviceNumber: !this.state.addDeviceNumber });

  async componentDidMount() {
    this.startLoading();
    await this.setDeviceData({ serial: "" });
    this.stopLoading();
  }

  setDeviceData = async (data) => {
    const { masterClpSerials } = this.context;
    await masterClpSerials(data);

     // Filter out devices with is_delete equal to 0
    const filteredClpSerialList = this.context.clpSerialList.filter(device => device.is_delete === 0);
  
    this.setState({
      devicesList: filteredClpSerialList.slice(this.state.begin, this.state.end),
    });
  };

  confirmAction = (message) => {
    return new Promise((resolve) => {
      const result = window.confirm(message);
      resolve(result);
    });
  };

  deleteDeviceNumber = async (serial) => {
    const { deleteClpSerials } = this.context;
    const data = {
      serial: serial,
    };

    // แสดงข้อความยืนยันการลบ
    const confirmDelete = await this.confirmAction("คุณต้องการลบข้อมูลหมายเลขเครื่องจักร " + serial + " ใช่หรือไม่?");
    if (!confirmDelete) {
      return; // ไม่ทำอะไรเมื่อผู้ใช้ยกเลิกการลบ
    }

    const formData = new FormData()
    formData.append("data", JSON.stringify(data));
    // statusForm = "delete";
    console.log("datadelete", data);
    
    let result = await deleteClpSerials(data);
    if (result?.result === "success") {  
      return this.alertDialog("สำเร็จ!", "ลบข้อมูลสำเร็จ", "success");   
    } else {
      return this.alertDialog("ผิดพลาด!", "ลบข้อมูลไม่สำเร็จ", "warning");
    } 
  };

  alertDialog = async (title, text, icon) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: "ok",
      confirmButtonColor: "#3085d6",
    });
  };

  onUploadDeviceNumberFile = async (e) => {
    const formData = new FormData();
    formData.append("file", e.target.files[0]);

    let result = await this.context.uploadMasterDeviceData(formData);

    if (result?.status?.result === "success") {
      await this.setDeviceData({ serial: "" });
      await this.alertDialog(
        "Success!",
        `${result?.status?.description}`,
        "success"
      );
    } else {
      this.alertDialog("Error!", `${result?.status?.description}`, "error");
    }
  };

  createDeviceSearch = () => {
    const { clpSerialList } = this.context;
    const { serialSearch } = this.state;
    const iotOptions = clpSerialList?.map((device) => ({
      key: device.serial,
      value: device.serial,
      text: device.serial,
    }));
    return (
      <div className="search">
        <Form>
          <b>หมายเลขเครื่องจักร</b>
          <Form.Group inline>
            <Form.Field
              control={Select}
              options={iotOptions}
              value={serialSearch}
              placeholder="หมายเลขเครื่องจักร"
              search
              onChange={(e, { value }) =>
                this.setState({ serialSearch: value })
              }
            />
            <Button
              onClick={() => {
                this.setDeviceData({ serial: "" });
                this.setState({
                  serialSearch: "",
                  level: -1,
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              รีเซต
            </Button>
            <Button
              color="blue"
              onClick={() => {
                this.setDeviceData({ serial: serialSearch });
                this.setState({
                  begin: 0,
                  end: 10,
                  activePage: 1,
                });
              }}
            >
              ค้นหา
            </Button>
            &emsp;
            <Button color="green" onClick={() => this.updateAddDeviceNumber()}>
              <Icon name="plus" />
              เพิ่มหมายเลขเครื่องจักร
            </Button>
            <input
              type="file"
              style={{ display: "none" }}
              ref="deviceNumber"
              multiple={false}
              onChange={this.onUploadDeviceNumberFile}
            />
            <Button color="teal" onClick={() => this.refs.deviceNumber.click()}>
              <Icon name="upload" />
              อัพโหลดหมายเลขเครื่องจักร
            </Button>
          </Form.Group>
          <Form.Group inline>
           
          </Form.Group>
        </Form>
      </div>
    );
  };

  createDataTable = () => {
    const { devicesList } = this.state;
    return (
      <Table celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>วันที่</Table.HeaderCell>
            <Table.HeaderCell>เวลา</Table.HeaderCell>
            <Table.HeaderCell>หมายเลขเครื่องจักร</Table.HeaderCell>
            <Table.HeaderCell>ลบข้อมูล</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {devicesList?.map((device, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{device.create_date}</Table.Cell>
              <Table.Cell>{device.create_time}</Table.Cell>
              <Table.Cell>{device.serial}</Table.Cell>
              <Table.Cell>
                <Button  
                  className="action-btn"
                  style={{
                    fontFamily: "Kanit",
                    fontSize: "16px",
                    backgroundColor: "#ff6347",
                  }} 
                    onClick={() => this.deleteDeviceNumber(device.serial)}>      
                  ลบข้อมูล
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  paginationUpdate = (e, data) => {
    const { clpSerialList } = this.context;
    const { pageSize } = this.state;

    let beginIdx = (data.activePage - 1) * pageSize;
    let endIdx = data.activePage * pageSize;

    this.setState({ activePage: data.activePage });
    this.setState({
      devicesList: [...clpSerialList.slice(beginIdx, endIdx)],
    });
  };

  render() {
    const { isLoading, activePage, pageSize, addDeviceNumber } = this.state;
    return (
      <div className="deviceNumber">
        <LetterLoading isOpen={isLoading} />
        <Sidebar tabActive="iotDevice" categories="deviceNumber" />
        <Navigation />

        <AddDeviceNumberModal
          isOpen={addDeviceNumber}
          isClose={this.updateAddDeviceNumber}
        />

        <div className="deviceNumber-content">
          <h2>หมายเลขเครื่องจักร</h2>
          <hr />

          <div className="deviceNumber-content-search">
            {this.createDeviceSearch()}
          </div>
          <div className="deviceNumber-content-table">
            {this.createDataTable()}
          </div>
          <div className="deviceNumber-content-pagination">
            <Pagination
              activePage={activePage}
              totalPages={Math.ceil(
                this.context.clpSerialList.length / pageSize
              )}
              onPageChange={this.paginationUpdate}
            />
          </div>
        </div>
      </div>
    );
  }
}

DeviceNumber.contextType = DeviceContext;
